/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Timestamp_In_FutureInputs */

const en_us2_workout_timestamp_in_future = /** @type {(inputs: Workout_Timestamp_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The phone's clock is ahead. Try again in a few minutes.`)
};

const pt_br2_workout_timestamp_in_future = /** @type {(inputs: Workout_Timestamp_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O relógio do celular está adiantado. Tente de novo em alguns minutos.`)
};

const es_419_workout_timestamp_in_future = /** @type {(inputs: Workout_Timestamp_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El reloj del teléfono está adelantado. Inténtalo de nuevo en unos minutos.`)
};

const pt_pt2_workout_timestamp_in_future = /** @type {(inputs: Workout_Timestamp_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O relógio do telemóvel está adiantado. Tenta de novo daqui a alguns minutos.`)
};

const fr_fr2_workout_timestamp_in_future = /** @type {(inputs: Workout_Timestamp_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'horloge du téléphone est en avance. Réessaie dans quelques minutes.`)
};

const de_de2_workout_timestamp_in_future = /** @type {(inputs: Workout_Timestamp_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Uhr deines Handys geht vor. Versuch es in ein paar Minuten erneut.`)
};

const it_it2_workout_timestamp_in_future = /** @type {(inputs: Workout_Timestamp_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'orologio del telefono è avanti. Riprova tra qualche minuto.`)
};

/**
* | output |
* | --- |
* | "The phone's clock is ahead. Try again in a few minutes." |
*
* @param {Workout_Timestamp_In_FutureInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_timestamp_in_future = /** @type {((inputs?: Workout_Timestamp_In_FutureInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Timestamp_In_FutureInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_timestamp_in_future(inputs)
	if (locale === "es-419") return es_419_workout_timestamp_in_future(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_timestamp_in_future(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_timestamp_in_future(inputs)
	if (locale === "de-DE") return de_de2_workout_timestamp_in_future(inputs)
	if (locale === "it-IT") return it_it2_workout_timestamp_in_future(inputs)
	return en_us2_workout_timestamp_in_future(inputs)
});
export { workout_timestamp_in_future as "workout.timestamp_in_future" }